// removed by extract-text-webpack-plugin
module.exports = {"att-logo":"LogoLoader__att-logo","attLogo":"LogoLoader__att-logo"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Loader/LogoLoader/LogoLoader.mobile.scss
// module id = 1706
// module chunks = 8